import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formDetails = {
    key: 'income',
    title: 'Monthly Income',
    formName: Routes.STEPONE,
    totalKey: 'totalIncome',
    fields: {
        yourIncome: {
            label: 'Your Monthly Net Income'
        },
        incomeAlt: {
            label: 'Your Spouse\'s Monthly Net Income'
        },
        other: {
            label: 'Other',
            tooltip: 'i.e.: government, second job, etc.'
        }
    }
};

const tracking = {
    eventAction: 'Budget Calculator - Step 1',
    eventLabel: 'Monthly Net Income'
};

const minValue = 0;
const minSalary = 1;

const validate = values => v(values, {
    yourIncome: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        numericality: {
            greaterThanOrEqualTo: minSalary,
            notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minSalary)}`
        }
    },
    incomeAlt: {
        numericality: {
            greaterThanOrEqualTo: minValue,
            notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minValue)}`
        }
    },
    other: {
        numericality: {
            greaterThanOrEqualTo: minValue,
            notGreaterThanOrEqualTo: `must be greater than or equal to $${numberWithCommas(minValue)}`
        }
    }
});

class StepOneForm extends Component {
    calculateTotal() {
        const {
            props: {
                formValues: {
                    [formDetails.totalKey]: removedTotal,
                    ...values
                }
            }
        } = this;

        return Object.values(values).reduce((total, val) => total + val, 0);
    }

    componentDidUpdate() {
        const {
            props: {
                changeFieldValue
            }
        } = this;

        changeFieldValue(formDetails.totalKey, this.calculateTotal());
    }

    render() {
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key => (
                        <Field
                            key={key}
                            type='text'
                            name={key}
                            label={formDetails.fields[key].label}
                            tooltip={formDetails.fields[key].tooltip}
                            prefix='$'
                            format={numberWithCommas}
                            parse={parseNumberWithCommas}
                            component={RenderInput}
                        />
                    ))
                }
            </form>
        );
    }
}

const formValues = getFormValues(formDetails.formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value))
});

StepOneForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    redirectPath: `/budget-planner${Routes.STEPTWO}`,
    skipPath: `/budget-planner${Routes.SUMMARY}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepOneForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepOneForm));
